/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

export enum NetworkStates {
  NetworkEmpty,
  NetworkIdle,
  NetworkLoading,
  NetworkNoSource
}